import tinycolor from 'tinycolor2';

interface ChangeToneProps {
  color: string;
  amount: number;
  darken?: boolean;
}

export const changeTone = ({
  color,
  amount,
  darken = false
}: ChangeToneProps) => {
  return darken
    ? tinycolor(color)
        .darken(amount * 100)
        .toRgbString()
    : tinycolor(color)
        .lighten(amount * 100)
        .toRgbString();
};
